var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditOptionSub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26C0 11.6406 11.6406 0 26 0H38.9999C53.3593 0 64.9999 11.6406 64.9999 26V38.9999C64.9999 53.3593 53.3593 64.9999 38.9999 64.9999H26C11.6406 64.9999 0 53.3593 0 38.9999V26Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3359 42.0469H51.187L51.0834 43.0814C50.7628 45.6343 48.9388 47.1249 47.0852 47.1249H19.4378C17.3428 47.1249 15.703 45.3301 15.4418 43.1004C15.4389 43.0772 15.4533 43.2186 15.3359 42.0469Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.758 26.4535L51.4229 39.7701H15.1164L13.8127 26.7362C13.4637 23.6797 16.7766 22.267 18.306 24.016C21.9857 28.2382 22.3796 29.0717 23.6157 28.9251C24.0803 28.8688 24.4123 28.6617 24.688 28.4089C32.1796 21.2564 31.6897 21.7196 31.7668 21.6589C32.7751 20.887 34.0717 21.0143 34.8314 21.6437C42.4012 27.9734 42.0504 27.6947 42.2194 27.7905C42.9262 28.1947 43.7598 28.1432 44.4722 27.4479C48.679 23.3345 48.4122 23.5908 48.4902 23.5287C50.4146 22.0377 53.066 23.7703 52.758 26.4535Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.22894e-7,
    y1: 3.2122,
    x2: 69.4278,
    y2: 8.20142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE875F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditOptionSub);
export default __webpack_public_path__ + "static/media/creditOption-sub.af0bd6a71af24e697a7e0a462e6a6d6b.svg";
export { ForwardRef as ReactComponent };